import {
  Alert, AlertTitle, Box, Button, Portal, Snackbar, Stack, Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
const APP_TOAST_Z_INDEX = 2147483647;

const SOFT_COLORS = {
  success: { bg: '#f0faf5', border: '#6fcf97', icon: '#27ae60', text: '#1a5c36' },
  error:   { bg: '#fff5f5', border: '#f1a0a0', icon: '#e53e3e', text: '#7b1c1c' },
  warning: { bg: '#fffbeb', border: '#f6d860', icon: '#d97706', text: '#7c4a00' },
  info:    { bg: '#eff6ff', border: '#93c5fd', icon: '#2563eb', text: '#1e3a6e' },
};

export default function AppToast({ toast, onClose }) {
  const { t } = useTranslation();
  const severity = toast?.severity || 'success';
  const palette = SOFT_COLORS[severity] ?? SOFT_COLORS.success;

  return (
    <Portal>
    <Snackbar
      open={Boolean(toast)}
      autoHideDuration={severity === 'error' ? 8000 : 4000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      sx={{ zIndex: APP_TOAST_Z_INDEX }}
    >
      <Alert
        severity={severity}
        variant="outlined"
        onClose={onClose}
        sx={{
          minWidth: 300,
          bgcolor: palette.bg,
          borderColor: palette.border,
          color: palette.text,
          boxShadow: '0 4px 16px rgba(0,0,0,0.10)',
          borderRadius: '8px',
          '& .MuiAlert-icon': { color: palette.icon },
          '& .MuiAlert-action .MuiIconButton-root': { color: palette.text },
        }}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <Box sx={{ minWidth: 0 }}>
            <AlertTitle sx={{ fontWeight: 700, color: palette.text, mb: 0.25 }}>
              {t('breadcrumb.appName')}
            </AlertTitle>
            <Typography variant="body2" sx={{ color: palette.text, opacity: 0.88 }}>
              {toast?.message}
            </Typography>
          </Box>
          {toast?.actionLabel && toast?.onAction && (
            <Button
              color="inherit"
              onClick={toast.onAction}
              size="small"
              sx={{ color: palette.text, flexShrink: 0 }}
            >
              {toast.actionLabel}
            </Button>
          )}
        </Stack>
      </Alert>
    </Snackbar>
    </Portal>
  );
}
